import { create, devtools, persist } from 'lib/zustand';

type AuthActions = {
  reset: () => void;
  setInitAuth(isAuthenticated: boolean): void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
};

type AuthState = {
  isAuthenticated: boolean;
};

const initialState: AuthState = {
  isAuthenticated: false,
};

const useAuthStore = create<AuthActions & AuthState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        reset() {
          set(initialState);
        },
        setInitAuth(isAuthenticated) {
          set({ isAuthenticated });
        },
        setIsAuthenticated(isAuthenticated) {
          set({ isAuthenticated });
        },
      }),
      {
        name: 'auth-session',
      },
    ),
  ),
);

export const useIsAuthenticated = () => useAuthStore((state) => state.isAuthenticated);
export const useSetIsAuthenticated = () => useAuthStore((state) => state.setIsAuthenticated);
